import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as actions from "./promotionCodeActions";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { of } from "rxjs";

export const promotionCodesListEpic: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(actions.LIST_PROMOTION_CODES),
    exhaustMap((action: actions.ListPromotionCodesAction) => {
      const state = state$.value;

      return services.apiPromotionCode
        .listForOrganization(
          authSelectors.accessToken(state),
          action.organization,
          action.page,
          action.filters
        )
        .pipe(
          map((response) =>
            actions.listPromotionCodesSuccessAction(
              action.organization,
              response.promotionCodes.items
            )
          ),
          catchError(() => {
            services.toastr.error(
              "Fail",
              "There was error while fetching promotion code list"
            );
            return of(
              actions.listPromotionCodesFailAction(action.organization)
            );
          })
        );
    })
  );
